import { getEventPublicAccess } from "@/lib/event-status";

export default function PublicEventBlocked({ title = "Not available", message, status }) {
  return (
    <div
      className="min-h-screen grid place-items-center px-6"
      style={{ background: "var(--bg-base)" }}
      data-testid="public-event-blocked"
    >
      <div className="max-w-md text-center">
        <div className="text-overline">{status ? String(status).toUpperCase() : "UNPUBLISHED"}</div>
        <h1 className="font-heading text-3xl mt-3 tracking-tight">{title}</h1>
        <p className="text-sm text-[var(--text-secondary)] mt-4 leading-relaxed">
          {message || "This event is not open to the public yet."}
        </p>
      </div>
    </div>
  );
}

export function getBlockedPresentation(event) {
  const access = getEventPublicAccess(event);
  if (access.siteVisible) return null;
  return {
    title: access.storedStatus === "draft" ? "Event not published" : "Event not available",
    message: access.message || "This event is not open to the public yet.",
    status: access.effectiveStatus || access.storedStatus,
  };
}

export function getRegistrationBlockedPresentation(event, registerMetaError) {
  const access = getEventPublicAccess(event);
  if (access.registrationOpen) return null;
  return {
    title: "Registration closed",
    message:
      registerMetaError ||
      access.message ||
      "Registration is not open for this event.",
    status: access.effectiveStatus || access.storedStatus,
  };
}
